import { render, staticRenderFns } from "./ShopChangeList.vue?vue&type=template&id=33d23d53&scoped=true"
import script from "./ShopChangeList.vue?vue&type=script&lang=js"
export * from "./ShopChangeList.vue?vue&type=script&lang=js"
import style0 from "./ShopChangeList.vue?vue&type=style&index=0&id=33d23d53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d23d53",
  null
  
)

export default component.exports